import { render, staticRenderFns } from "./PartnerSecurity.vue?vue&type=template&id=8b0ec0b8"
import script from "./PartnerSecurity.vue?vue&type=script&lang=ts"
export * from "./PartnerSecurity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports